import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Tooltip, OverlayTrigger} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaCheck} from "react-icons/fa";
import 'react-quill/dist/quill.snow.css'

class ProjetosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            nomeHelper: '',
            descricao: '',
            erroLoadRegistro: "",
            projeto_id: "",
            titulo_pagina: "",
            loading: false,
        };

    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                projeto_id: id,
                titulo_pagina: 'Editando Projeto',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/inventario/projetos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    descricao: dados.descricao,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar Projeto, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                projeto_id: '',
                titulo_pagina: 'Adicionar Projeto',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.projeto_id) ? '/inventario/projetos/'+this.state.projeto_id+'/' : '/inventario/projetos/'
        const metodo = (this.state.projeto_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.projeto_id) ? 'Projeto atualizado com sucesso' : 'Projeto cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.projeto_id){
                this.props.router.navigate("/projeto");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o Projeto, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosProjeto" id="tabs-projeto" className="aditus-tabs">
                    <Tab eventKey="dadosProjeto" title="Dados do Projeto">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Projeto</h4>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Projeto</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Projeto" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="descricao"
                                                    value={this.state.descricao}
                                                    onChange={this.handleChange}
                                                    placeholder="Informações adicionais sobre o projeto..."
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ProjetosEdit);